export function generateCode() {
  const { paddingSize, numberOfImages, imagesPerRowInMobile } = this.state;
  const maxWidth = 640; // standard width
  const w = paddingSize * (numberOfImages + 1); // used right below, ESLint keeps messing up parenthesis required
  const itemWidth = (maxWidth - w) / numberOfImages; // calculate itemWidth using maxWidth and number of images + padding size.

  let imageBaseUrl = `${this.state.baseDISHost}/customer/${this.state.customerId}/image.jpg?auth_token=${
    this.state.authToken
  }&download=1&size=${this.state.imageSize}&sorting_option=${this.state.sortingOption}`;

  if (this.state.filterType !== 'media_library' && this.state.filterType && this.state.filterValue) {
    imageBaseUrl += `&filter=${this.state.filterType}&filter_value=${this.state.filterValue}`;
  }

  if (this.state.fallbackImage) {
    imageBaseUrl += `&fallback_image=${encodeURIComponent(this.state.fallbackImage)}`;
  }

  if (this.state.cropping) {
    imageBaseUrl += `&crop_size=${this.state.cropSize.width}x${this.state.cropSize.height}`;
    imageBaseUrl += `&crop_fit=${this.state.cropFit}`;

    if (this.state.cropFit === 'cover') {
      imageBaseUrl += `&crop_position=${this.state.cropPosition}`;
    }

    if (this.state.cropFit === 'contain') {
      imageBaseUrl += `&crop_background=${
        this.state.cropBackground === 'hex' ? this.state.cropBackgroundHex.replace(/#/g, '') : this.state.cropBackground
      }`;
    }
  }

  const imageTags = Array(this.state.numberOfImages)
    .join(0)
    .split(0)
    .map((item, i) => `${imageBaseUrl}&position=${i}`);

  let templateObjects = [];

  while (imageTags.length > 0) {
    templateObjects.push(imageTags.splice(0, imagesPerRowInMobile));
  }

  let htmlOutput = `
      <style>
      /* Some resets and issue fixes */
      html, body { margin: 0; padding: 0 }
      #outlook a { padding:0; }
      .olapic { width:100% !important; -webkit-text; size-adjust:100%; -ms-text-size-adjust:100%; margin:0; padding:0; }
      .ReadMsgBody { width: 100%; }
      .ExternalClass {width:100%;}
      .backgroundTable {margin:0 auto; padding:0; width:100%;!important;}
      table td {border-collapse: collapse;}
      .ExternalClass * {line-height: 115%;}
      .olapic img {width: 100%}
      /* End reset */

      /* These are our tablet/medium screen media queries */
      @media screen and (max-width: 630px){

          /* Display block allows us to stack elements */
          *[class="mobile-column"] {display: block;}

          /* Some more stacking elements */
          *[class="mob-column"] {float: none !important;width: 100% !important; padding: 0 !important}

          /* Hide stuff */
          *[class="hide"] {display:none !important;}

          /* This sets elements to 100% width and fixes the height issues too, a god send */
          *[class="100p"] {width:100% !important; height:auto !important;}

          /* For the 2x2 stack */
          *[class="condensed"] {padding-bottom:0 !important; display: block;}

          /* Mobile width reset for single row layout */
          *[class="mobile-width-reset"] {width: ${(100 / imagesPerRowInMobile).toFixed(2)}% !important;}

          /* Centers content on mobile */
          *[class="center"] {text-align:center !important; width:100% !important; height:auto !important;}

          /* 100percent width section with ${paddingSize}px padding */
          *[class="100pad"] {width:100% !important; padding:${paddingSize}px;}

          /* 100percent width section with ${paddingSize}px padding left & right */
          *[class="100padleftright"] {width:100% !important; padding:0 ${paddingSize}px 0 ${paddingSize}px;}

          /* 100percent width section with ${paddingSize}px padding top & bottom */
          *[class="100padtopbottom"] {width:100% !important; padding:${paddingSize}px 0px ${paddingSize}px 0px;}
      }
    </style>
    <table width="${maxWidth}" border="0" cellspacing="0" paddingSize="${paddingSize}" class="100p olapic">
    <tr>
      <td align="center" valign="top">
        <table border="0" paddingSize="0" cellspacing="0" class="100padtopbottom" width="${maxWidth - paddingSize * 2}">
          <tr>`;

  templateObjects.forEach((rowArray, templateObjectIndex, templateObjects) => {
    const isLastTemplateObjectItem = Object.is(templateObjects.length - 1, templateObjectIndex);
    const modulus = imagesPerRowInMobile % rowArray.length;
    const totalWidthOfItems = itemWidth * rowArray.length;
    let paddingToAccount;
    if (modulus === 0) {
      paddingToAccount = paddingSize * (imagesPerRowInMobile - 1);
    } else {
      paddingToAccount = paddingSize * (modulus - 1);
    }
    if (isLastTemplateObjectItem && (modulus === 0) & (rowArray.length === 1)) {
      paddingToAccount = 0;
    }
    const rowWidth = totalWidthOfItems + paddingToAccount;

    htmlOutput += `
    <td align="left" class="condensed" valign="middle">
      <table align="left" border="0" paddingSize="0" cellspacing="0" class="mob-column" width="${rowWidth}">
        <tr>
          <td valign="top" align="center">
            <table border="0" cellspacing="0" paddingSize="0">
              <tr>
                <td valign="top" align="center">
                  <table border="0" cellspacing="0" paddingSize="0"><tr>`;

    rowArray.forEach((imageUrl, rowArrayIndex) => {
      htmlOutput += `<td width="${itemWidth}" align="center" class="mobile-width-reset">
        <a href="#"
          ><img
            src="${imageUrl}"
            border="0"
            style="display:block;"
            class="image 100p"
        /></a>
      </td>`;

      if (!Object.is(rowArray.length - 1, rowArrayIndex)) {
        htmlOutput += `<td width="${paddingSize}" class="hide"></td>`;
      }
    });

    htmlOutput += `</tr></table></td></tr></table></td></tr></table></td>`;
    if (!isLastTemplateObjectItem) {
      htmlOutput += `<td width="${paddingSize}" class="hide"></td>`;
    }
  });

  htmlOutput += `</tr></table></td></tr></table>`;

  return htmlOutput;
}



// WEBPACK FOOTER //
// ./src/components/SnippetGenerator/snippetGenerator.js